import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import { DocumentSection } from '@/sections/documents/DocumentSection';
import { LINKS } from '@/constants/links';
export function PersonalInformationManagement() {
  const $ = _c(26);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["personalData"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("categories.2.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("categories.2.texts.1");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <p className="mb-4">{t2}</p>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("categories.2.texts.2");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <p className="mb-4">{t4}</p>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("categories.2.texts.3");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <p className="mb-8">{t6}</p>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = LINKS();
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = t8.personalInformation;
  let t10;
  if ($[16] !== t) {
    t10 = t("categories.2.cta");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <Button variant="secondary" size="lg" testId="personalInformation" analyticsParam="personalInformation" to={t9}>{t10}</Button>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t1 || $[21] !== t11 || $[22] !== t3 || $[23] !== t5 || $[24] !== t7) {
    t12 = <DocumentSection title={t1} isDropdown={false} id="personalInformation">{t3}{t5}{t7}{t11}</DocumentSection>;
    $[20] = t1;
    $[21] = t11;
    $[22] = t3;
    $[23] = t5;
    $[24] = t7;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}